// Styles
import "vuetify/styles";
// Vuetify
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import { aliases, mdi } from "vuetify/iconsets/mdi";

import * as labs from "vuetify/labs/components";

const vuetify = createVuetify({
  components: {
    ...labs,
    ...components,
    ...directives,
  },
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1400,
    },
  },
  rtl: false,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    defaultTheme: "light",
    themes: {
      light: {
        background: "#1E3A8A",
        colors: {
          primary: "#16216A",
          secondary: "#FDB813",
          tertiary: "#EDFED3",
          textcolor: "#101828",
          textgray: "#667085",
          textwhite: "#F2F2F2",
          offwhite: "#F2F2F2",
          lightgray: "#E5E7EB",
          text_white_light: "#F7F7F7",
          blue: "#D3F9FE",
          light_purple: "#D3DAFE",
          light_red: "#FED3D3",
          light_blue: "#D3FEFB",
          yellow: "#FEF2D3",
          light: "#f4f5f7",
          black: "#000000",
          white: "#FFFFFF",
          darkblue: "#101828",
        },
      },
      dark: {
        background: "#1E3A8A", // Replace with your desired background color

        colors: {
          primary: "#F24139",
          secondary: "#403E48",
        },
      },
    },
  },
});

export default vuetify;
